import { render, staticRenderFns } from "./SalonEnVivo.vue?vue&type=template&id=211f8dc4&"
import script from "./SalonEnVivo.vue?vue&type=script&lang=js&"
export * from "./SalonEnVivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports